<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="4"
        md="6"
      >
        <UserCardLandingPage />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <AdminCreditLimitOverview />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="4"
        md="12"
        sm="12"
      >
        <b-row class="match-height">
          <b-col
            lg="12"
            md="12"
            cols="12"
          >
            <FavoriteWidget />
          </b-col>

        </b-row>
      </b-col>
      <b-col
        lg="8"
        md="12"
        sm="12"
      >
        <AdminPendingActions />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { useActions } from 'vuex-composition-helpers'
import { onMounted } from '@vue/composition-api'
import UserCardLandingPage from './UserCardLandingPage.vue'
import AdminCreditLimitOverview from './AdminCreditLimitOverview.vue'
import FavoriteWidget from './FavoriteWidget.vue'
import AdminPendingActions from './AdminPendingActions.vue'
import { dashboardPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    UserCardLandingPage,
    AdminCreditLimitOverview,
    FavoriteWidget,
    AdminPendingActions,
  },
  setup() {
    const {
      getTillAccountList,
      getVaultAccountList,
      getBranches,
      getBanks,
      getIncomeGLAccount,
      getIncomeGLByParentCategory,
      getStationaryAccount,
      getCurrentFinancialDate,
      getCorporateInformation,
    } = useActions({
      getTillAccountList: 'operations/getTillAccountList',
      getVaultAccountList: 'operations/getVaultAccountList',
      getBranches: 'operations/getAllBranches',
      getBanks: 'operations/getBanks',
      getIncomeGLAccount: 'account/getIncomeGLAccount',
      getIncomeGLByParentCategory: 'account/getIncomeGLByParentCategory',
      getStationaryAccount: 'account/getStationaryAccount',
      getCurrentFinancialDate: 'operations/getCurrentFinancialDate',
      getCorporateInformation: 'operations/getCorporateInformationList',
    })

    const fetchData = async () => {
      await getCorporateInformation({ permission: dashboardPermissions.VIEW_ADMIN_APPROVALS })
      await getVaultAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'VIEW_ADMIN_APPROVALS',
      })
      await getTillAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'VIEW_ADMIN_APPROVALS',
      })
      await getBanks({ permission: 'VIEW_ADMIN_APPROVALS' })
      await getCurrentFinancialDate({ permission: 'VIEW_ADMIN_APPROVALS' })
      await getBranches({
        search: '',
        page: 0,
        limit: 0,
        permission: 'VIEW_ADMIN_APPROVALS',
      })
      await getIncomeGLAccount({ permission: 'VIEW_ADMIN_APPROVALS' })
      await getIncomeGLByParentCategory({ permission: 'VIEW_ADMIN_APPROVALS' })
      await getStationaryAccount({ permission: 'VIEW_ADMIN_APPROVALS' })
    }
    onMounted(async () => {
      await fetchData()
    })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
